import { deviceEventType } from '#type';

const getEventIdsByKeyPrefix = (eventTypes, prefix) =>
  Object.entries(eventTypes)
    .filter(([key]) => key.startsWith(prefix))
    .map(([, id]) => id);

export const deviceLogFilterServiceOptions = {
  eventTypes: {
    EDIT_SETTINGS: deviceEventType.EDIT_SETTINGS
  },
  eventGroups: [
    {
      key: 'ADD_DEVICE',
      label: 'Add device',
      eventIds: getEventIdsByKeyPrefix(deviceEventType, 'ADD_DEVICE')
    },
    {
      key: 'REMOVE_DEVICE',
      label: 'Remove device',
      eventIds: getEventIdsByKeyPrefix(deviceEventType, 'REMOVE_DEVICE')
    }
  ]
};
